import React, { useState } from 'react';
import { Button } from 'antd';
import { useNavigate, useLocation } from '@common/hooks';
import { Colors, FontSize, FontWeight, LineHeight } from '@common/tokens';
import { LastVisitedPageModal } from './_last-visited-page-modal';
import Auth from 'works/legacy/lib/auth';
import { TimeWithTimeZone } from '@common/components';

export function LastVisitedPageSection() {
  const navigate = useNavigate();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);

  const lastVisitedPagePath = Auth.path();
  const lastVisitedPageLabel = Auth.pathLabel();
  const lastVisitedPageUpdatedAt = Auth.pathUpdatedAt();
  const saveLastVisitedPage = Auth.saveLastVisitedPage();
  const userHasAlreadyDecided = typeof saveLastVisitedPage === 'boolean';

  const handleLinkLabel = () => {
    if (lastVisitedPageLabel) {
      return lastVisitedPageLabel;
    }

    if (['/works', '/works/supplier'].includes(lastVisitedPagePath || '')) {
      return 'Home Page';
    }

    return lastVisitedPagePath;
  };

  if (!lastVisitedPageLabel && !lastVisitedPagePath) {
    return null;
  }

  return (
    <>
      <LastVisitedPageModal
        userHasAlreadyDecided={userHasAlreadyDecided}
        open={openModal}
        onClose={() => setOpenModal(false)}
        onRedirectToSavedRoute={() => {
          if (lastVisitedPagePath !== location.pathname) {
            navigate(lastVisitedPagePath as string);
          }
        }}
      />
      <div className="last-visited-page-section">
        <div>
          Last Visited:{' '}
          <Button
            type="link"
            className="last-visited-page__link"
            onClick={() => setOpenModal(true)}
          >
            {handleLinkLabel()}
          </Button>
        </div>
        <div className="last-visited-page-section__time">
          <TimeWithTimeZone
            date={lastVisitedPageUpdatedAt || ''}
            variant="long_format"
          />
        </div>
      </div>
      <style jsx>{`
        .last-visited-page-section {
          display: flex;
          justify-content: space-between;
          border: 1px solid ${Colors.steel};
          padding: 12px 16px;
          border-radius: 8px;
          font-weight: 400;
        }

        .last-visited-page-section__time {
          line-height: ${LineHeight.xxl};
        }

        :global(.last-visited-page__link) {
          padding: 0;
          font-size: ${FontSize.md};
          font-weight: ${FontWeight.medium};
        }

        :global(.last-visited-page__link span) {
          max-width: 480px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          vertical-align: middle;
        }

        @media screen and (min-width: 1326px) {
          :global(.last-visited-page__link span) {
            max-width: 860px;
          }
        }
      `}</style>
    </>
  );
}
